<template>
  <div id="app" style="height: 100%;">
    <div>
      <router-view />
    </div>
    <div>
      <vue-sidebar v-if="$store.state.webNavigator=='pc'"/>
    </div>
    <div>
      <TopNavigation v-if="$store.state.webNavigator=='phone'&&$store.state.mainNavShowStatus"/>
    </div>
  </div>
</template>

<script>
import TopNavigation from './components/TopMainNav/TopMainNav';
import 'vant/lib/index.css';
export default {
  name: 'App',
  components: {TopNavigation, },
  data () {
    return {};
  },
  // async beforeMount () {
  //   // 浏览器内核判断
  //   this.$store.commit('navigatorReg');
  // },
  async mounted () {
    // document.getElementById('cnzz_stat_icon_1279115503').style.display = 'none';
    let that = this;
    // this.$store.state.webNavigator   pc  phone
    // 屏幕分辨率判断
    window.addEventListener('resize', function () {
      if (!that.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        that.timer = true;
        setTimeout(function () {
          // 打印screenWidth变化的值
          // console.log(document.body.clientWidth, '屏幕宽度');
          let type = 'pc';
          if (document.body.clientWidth <= 800) {
            type = 'phone';
          }
          that.$store.commit('changeNavigator', type);
          that.timer = false;
        }, 300);
      }
    });
  },
  methods: {},
  watch: {
    // $route (to, form) {
    //   // 浏览器内核判断
    //   this.$store.commit('navigatorReg');
    // },
  },
};
</script>

<style lang="less">
@import "../static/css/common";
</style>



// WEBPACK FOOTER //
// App.vue